import { Button, Modal } from "react-bootstrap";
import { LuX } from "react-icons/lu";

/**
 * Confirmation modal for passkey deletion
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether modal is visible
 * @param {Object} props.passkey - Passkey object to delete
 * @param {Function} props.onConfirm - Callback when user confirms deletion
 * @param {Function} props.onCancel - Callback when user cancels deletion
 * @returns {JSX.Element} Rendered confirmation modal
 */
const DeleteModal = ({ show, passkey, onConfirm, onCancel }) => {
  return (
    <Modal show={show} onHide={onCancel} centered contentClassName="delete-modal">
      <button onClick={onCancel} className="position-absolute right-0 top-0 btn"><LuX size={28} /></button>
      <Modal.Body>
        <div className="d-flex align-items-center mb-3">
          <div>
            <h5 className="text-center mb-4">Delete Passkey?</h5>
            <p className="mb-2">
              Are you sure you want to delete the passkey{" "}
              <strong>"{passkey?.name || "Unknown"}"</strong>?
            </p>
            <p className="text-muted small mb-0">
              This action cannot be undone. You'll need to set up a new passkey
              if you want to use passkey authentication again.
            </p>
          </div>
        </div>
        <Button
          variant="warning"
          className="racq-primary-btn w-100 mb-3 mt-4"
          onClick={onConfirm}
        >
          <b>Delete passkey</b>
        </Button>
        <Button variant="outline" className="w-100 racq-secondary-btn" onClick={onCancel}>
          <b>Cancel</b>
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
